import { render, staticRenderFns } from "./Step4A.vue?vue&type=template&id=45f1640b&scoped=true&"
import script from "./Step4A.vue?vue&type=script&lang=js&"
export * from "./Step4A.vue?vue&type=script&lang=js&"
import style0 from "./Step4A.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Step4A.vue?vue&type=style&index=1&id=45f1640b&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f1640b",
  null
  
)

export default component.exports